import React from 'react';
import { Modal } from 'antd';
// import { ExclamationOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const Popup = ({ confirmPopup, setConfirmPopup }) => {
    const handleClose = () => {
        setConfirmPopup(false)
    }
    return (
        <>
            <Modal
                title="Record Locked"
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                footer={false}
            >
                {/* <div style={{ padding: "0px 20px" }} > */}
                <div className='' style={{ fontSize: 15 }}>
                    {/* <p style={{ fontWeight: 600 }}> <ExclamationOutlined style={{ color: '#f28e42' }} /> Your action has triggered an approval process</p> */}
                    <p>This record is now in the approval queue, and further changes are restricted until the approval process is complete.</p>
                </div>
                {/* </div> */}
            </Modal >
        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
};

export default Popup;